import React, { useState } from "react";
import amerMainPhoto from "../../assets/amer.jpeg";
import { useLanguage } from "../../Context/LanguageContext";
import "../WelcomePage/WelcomePage.css";
import EyeOnTheFutureInstitute from "../ExtraInfo/EyeOnTheFuture/EyeOnTheFuture";

function WelcomePage() {
  const { language } = useLanguage();
  const [openAboutEyeOnTheFuture, setOpenAboutEyeOnTheFuture] = useState(false)

  return (
    <div>
        {openAboutEyeOnTheFuture? <EyeOnTheFutureInstitute setOpenAboutEyeOnTheFuture= {setOpenAboutEyeOnTheFuture}/>:
      <div dir={language === "arabic" ? "rtl" : "ltr"} className="welcome-page">    
        <div
          className={
            language === "arabic"
              ? "welcome-container welcome-arabic"
              : "welcome-container"
          }
        >
          {language === "english" ? (
            <div className="about">
              <h2>Physicist & web developer</h2>
              <div className="who">
                <h4>Who is Amer?</h4>
                <p><span className="amer-position">Company Owner: Eye On The Future</span></p>
                <p className="pargraph-about-amer">
                  A skilled and enthusiastic programmer and web developer with a
                  foundational education in Physics. A creative and innovative
                  problem solver who lives for learning. Sociable, open and
                  willing to work hard.
                </p>
                <div className="btn-eyeonthefuture-container">
                <button className='company-info' onClick={() => setOpenAboutEyeOnTheFuture(true)}>About Eye On The Future</button>
                </div>
              </div>
            </div>
          ) : language === "dutch" ? (
            <div className="about"></div>
          ) : language === "arabic" ? (
            <div className="about">
              <h2> فيزيائي & مطور تطبيقات الويب</h2>
              <div className="who">
                <h4>من هو عامر؟</h4>
                <p>
                  مبرمج ومطور ويب ماهر ومتحمس مع خلفية أكاديمية في الفيزياء. مبدع
                  ومبتكر في حل المشكلات يعيش من أجل التعلم. اجتماعي ومنفتح ومستعد
                  للعمل الجاد.
                </p>
              </div>
            </div>
          ) : (
            ""
          )}
          <div>
            <img src={amerMainPhoto} alt="amer" />
          </div>
        </div>
      </div>}
    </div>
  );
}

export default WelcomePage;
